import { api } from '@/services/api'
import { put } from 'redux-saga/effects'
import { fetchQuickReplyMessagesAction } from '../../actions'
import { FetchQuickReplyMessagesResponse } from './types'

export function* fetchQuickReplyMessagesSaga(action: ReturnType<typeof fetchQuickReplyMessagesAction.request>) {
  try {
    const { companyId, ownerId } = action.payload
    const response = yield api.get<FetchQuickReplyMessagesResponse>(`/reply/get-replies-by-company`, {
      params: { companyId, ownerId, isDisabled: false }
    })

    yield put(fetchQuickReplyMessagesAction.success({ quickReplies: response.data.replies }))
  } catch (error) {
    yield put(fetchQuickReplyMessagesAction.failure(error))
  }
}
